import React, { useState, useEffect } from 'react';
import SideMenu from "../../component/SideMenu";
import Topbar from "../../component/Topbar";
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseurl } from '../../baseurl';
import { Eye, ListCheck, Upload } from 'lucide-react';
import { Link } from 'react-router-dom';

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'desc' });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
 
  const adminToken = localStorage.getItem('adminToken');
console.log("adminToken", adminToken);


  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseurl}getAllUsers`, {
          headers: { Authorization: `Bearer ${adminToken}` }
        });
        if (response.data.success) setUsers(response.data.users);
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to fetch users' });
      } finally {
        setTimeout(() => setLoading(false), 800); // Slight delay to show skeleton
      }
    };
    fetchUsers();
  }, [adminToken]);

  // --- Logic: Sorting ---
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const sortedUsers = [...users].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  // --- Logic: Filtering ---
  const filteredUsers = sortedUsers.filter(u => 
    `${u.first_name} ${u.last_name} ${u.email} ${u.company_name}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // --- Logic: Pagination ---
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredUsers.slice(indexOfFirstRow, indexOfLastRow);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  };

  // --- Component: Skeleton Row ---
  const SkeletonRow = () => (
    <tr className="skeleton-row">
      <td colSpan="8"><div className="skeleton-line"></div></td>
    </tr>
  );


;


  return (
       <div className="app-container">
      <Topbar />
      <div className="main-wrapper" style={{ background: '#F4F7FE', display: 'flex' }}>
        {/* <SideMenu /> */}
        <div className="profile-content-container UD-page-wrapper p-2" style={{ flex: 1, overflow: 'auto' }}>
          
          <div className="d-flex justify-content-between align-items-end mb-4">
            <div>
              <h2 className="fw-bold mb-1" style={{ color: '#1B2559' }}>User Directory</h2>
              <p className="text-muted m-0">Review and manage system access for all clients.</p>
            </div>
            <div className="text-end">
               <span className="badge rounded-pill bg-white text-primary px-3 py-2 shadow-sm border">
                {filteredUsers.length} Active Accounts
               </span>
            </div>
          </div>

          {/* CONTROL BOX */}
          <div className="card border-0 shadow-sm mb-4 p-3" style={{ borderRadius: '15px' }}>
            <div className="row g-3 align-items-center">
              <div className="col-md-4">
                <div className="input-group input-group-merge border rounded-3  bg-light m-0">
                  <span className="input-group-text bg-transparent border-0"><i className="fa-solid fa-magnifying-glass text-muted"></i></span>
                  <input 
                    type="text" 
                    className="form-control bg-transparent border-0 shadow-none" 
                    placeholder="Search identity, email or company..." 
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <select className="form-select border-0 bg-light rounded-3" onChange={(e) => handleSort(e.target.value)}>
                  <option value="created_at">Sort by: Joined Date</option>
                  <option value="first_name">Sort by: Name</option>
                  <option value="plan_type">Sort by: Plan</option>
                </select>
              </div>
              <div className="col-md-5 d-flex justify-content-end gap-2">
                <div className="d-flex align-items-center gap-2">
                  <small className="text-muted text-nowrap">Rows per page:</small>
                  <select className="form-select form-select-sm w-auto" style={{minWidth: '100px'}} onChange={(e) => setRowsPerPage(Number(e.target.value))}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: '15px' }}>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="ps-4 border-0 text-muted small fw-bold">ID</th>
                    <th className="border-0 text-muted small fw-bold cursor-pointer" onClick={() => handleSort('first_name')}>USER INFO <i className="fa-solid fa-sort ms-1"></i></th>
                    <th className="border-0 text-muted small fw-bold">COMPANY</th>
                    <th className="border-0 text-muted small fw-bold text-center">SOURCE</th>
                    <th className="border-0 text-muted small fw-bold text-center">PLAN</th>
                    <th className="border-0 text-muted small fw-bold" onClick={() => handleSort('created_at')}>JOINED <i className="fa-solid fa-sort ms-1"></i></th>
                    <th className="border-0 text-muted small fw-bold text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    [1,2,3,4,5].map(i => <SkeletonRow key={i} />)
                  ) : currentRows.length > 0 ? (
                    currentRows.map((user) => (
                      <tr key={user.id}>
                        <td className="ps-4 text-muted">#{user.id}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="avatar-sm me-3">{user.first_name[0]}{user.last_name[0]}</div>
                            <div>
                              <div className="fw-bold text-dark">{user.first_name} {user.last_name}</div>
                              <div className="small text-muted">{user.email}</div>
                            </div>
                          </div>
                        </td>
                        <td><span className="text-dark fw-500">{user.company_name}</span></td>
                        <td className="text-center"><span className="text-capitalize text-muted small">{user.source || 'Direct'}</span></td>
                        <td className="text-center">
                          <span className={`badge-plan ${user.plan_type?.toLowerCase() || 'free'}`}>
                            {user.plan_type || 'Free'}
                          </span>
                        </td>
                        <td className="text-muted small">{formatDate(user.created_at)}</td>
                        <td className="text-center">


  <Link to={`/bulk-list/${user.id}`} className="btn btn-outline-secondary  btn-sm px-3 rounded-pill me-2">
                         <ListCheck size={17} />  All Bulk
                          </Link>


  <Link to={`/bulk-update/${user.id}`} className="btn btn-outline-secondary  btn-sm px-3 rounded-pill me-2">
                         <Upload size={17} />  Bulk
                          </Link>


                          <Link to={`/user-detail/${user.id}`} className="btn btn-outline-primary btn-sm px-3 rounded-pill">
                         <Eye />   View Details
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="8" className="text-center py-5 text-muted">No matching users found.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
        /* User Avatars */
.avatar-sm {
  width: 38px;
  height: 38px;
  background: #E9EDF7;
  color: #4318FF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-weight: bold;
  font-size: 13px;
}

/* Plan Badges */
.badge-plan {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}
.badge-plan.pro { background: #E1F5FE; color: #039BE5; }
.badge-plan.enterprise { background: #FFF3E0; color: #F57C00; }
.badge-plan.free { background: #F5F5F5; color: #757575; }

/* Skeleton Loading Animation */
.skeleton-row td { padding: 25px 0; }
.skeleton-line {
  height: 20px;
  width: 90%;
  margin: 0 auto;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.cursor-pointer { cursor: pointer; }
.fw-500 { font-weight: 500; }
`}
      </style>
    </div>
  );
};

export default AllUsers;